var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"LDialog"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"LDialog-mask",on:{"click":_vm.close}},[_c('div',{staticClass:"LDialog-container",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }